import React, { useEffect, useState } from "react";
import Layout from "../component/Layout/Layout";
import { Link } from "react-router-dom";
import { useAuth } from "../context/auth";
import axios from "axios";
import { Form, Modal, Button } from "react-bootstrap";
import { useCustomerAddList } from "../hooks/useAllCategoryData";
import CountryPhone from "../component/CountryPhone";
import countryState from "../countriesStates.json";
import {
  deleteCustomerAddressAPI,
  getCustomerAddressAPI,
  updateCustomerAddressAPI,
  addCustomerAddressAPI,
} from "../component/APIS";
import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { getOnlyPhoneNo } from "../Helper";
import { Typeahead } from "react-bootstrap-typeahead";
import IntlTelInputBox from "../component/login/IntlTelInputBox";
import CurrentLocation from "../component/Checkout/CurrentLocation";
const MyAddress = () => {
  const [fullPhone, setFullPhone] = useState("");
  const [typehCountry, setTypehCountry] = useState([]);
  const [typehState, setTypehState] = useState([]);
  const [addTypehCountry, setAddTypehCountry] = useState([]);
  const [addTypehState, setAddTypehState] = useState([]);
  const [validated, setValidated] = useState(false);
  const [addValidated, setAddValidated] = useState(false);
  const queryClient = useQueryClient();
  //const [loading, setLoading] = useState(false);
  //const[selectedCode, setSelectedCode] = useState('+91');
  const [auth] = useAuth();
  const [userId, setUserId] = useState(auth?.user.id);
  //const [addressId, setAddressId]=useState('');
  const [updateMsg, setUpdateMsg] = useState("");
  const [removeMsg, setRemoveMsg] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [allCountry, setAllCountry] = useState([]);
  const [currentAdd, setCurrentAdd] = useState({
    customer_id: userId,
    contact_person_name: "",
    c_code: "",
    phone: "",
    address_type: "",
    country: "",
    state: "",
    city: "",
    zip: "",
    landmark: "",
    address: "",
  });

  const [addCurrentAdd, setAddCurrentAdd] = useState({
    customer_id: userId,
    contact_person_name: "",
    c_code: "",
    phone: "",
    address_type: "",
    country: "",
    state: "",
    city: "",
    zip: "",
    landmark: "",
    address: "",
  });

  const locaCountry = JSON.parse(sessionStorage.getItem("country_data"));
  const { country_code, country_name } = locaCountry;
  const [currentState, setCurrentState] = useState("");
  const {
    data: addrData,
    isLoading,
    isError,
    isLoadingError,
  } = useQuery({
    queryKey: ["address", userId],
    queryFn: () => getCustomerAddressAPI(userId),
    staleTime: 5 * 1000,
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleEdit = (id) => {
    setUpdateMsg("");
    //setAddressId(id)
    const addr = addrData.filter((item) => item.id === id);
    if (addr.length > 0) {
      const add_main = addr[0];
      setCurrentAdd(add_main);
      getStateByCountry(add_main?.country);
      setTypehCountry([add_main?.country]);
      setTypehState([add_main?.state]);
      setFullPhone(add_main?.phone);
    }
    setShow(true);
  };

  const getCountryState = async () => {
    if (countryState.length > 0) {
      const state = countryState
        .filter((item) => item?.iso2 === country_code)
        .map((item, i) => item?.states);
      const country = countryState.map((item, i) => item?.name);
      if (state.length > 0) {
        setCurrentState(state[0]);
      }
      if (country.length > 0) {
        setAllCountry(country);
      }
    }
  };

  const getStateByCountry = async (country) => {
    if (countryState.length > 0) {
      const state = countryState
        .filter((item) => item?.name === country)
        .map((item, i) => item?.states);
      if (state.length > 0) {
        setCurrentState(state[0]);
      }
    }
  };

  useEffect(() => {
    getCountryState();
    //eslint-disable-next-line
  }, []);
  const changeHandle = async (event) => {
    let value = event.target.value;
    value = value.trimStart();
    let name = event.target.name;
    if (name === "country") {
      setCurrentAdd({
        ...currentAdd,
        country: value,
        state: "",
      });
      getStateByCountry(value);
      setTypehState([]);
    } else {
      setCurrentAdd({
        ...currentAdd,
        [name]: value,
      });
    }
    //console.log(name,value)
  };

  const addChangeHandle = async (event) => {
    let value = event.target.value;
    value = value.trimStart();
    let name = event.target.name;
    if (name === "country") {
      setAddCurrentAdd({
        ...addCurrentAdd,
        country: value,
        state: "",
      });
      getStateByCountry(value);
      setAddTypehState([]);
    } else {
      setAddCurrentAdd({
        ...addCurrentAdd,
        [name]: value,
      });
    }
    //console.log(name,value)
  };

  const editMutation = useMutation({
    mutationFn: updateCustomerAddressAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["address"] });
      handleClose();
      setTimeout(() => {
        setUpdateMsg("");
    }, 2000);
      
    },
  });

  const addMutation = useMutation({
    mutationFn: addCustomerAddressAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["address"] });
      handleClose();
      setTimeout(() => {
        setUpdateMsg("");
    }, 2000);
      
    },
  });

  const handleUpdateAddress = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    }
    setValidated(true);
    if (form.checkValidity() === true) {
      setUpdateMsg("Address updated successfully!");
      editMutation.mutate({ ...currentAdd, phone: fullPhone });
    }
  };

  const handleAddAddressSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    }
    setAddValidated(true);
    if (form.checkValidity() === true) {
      //console.log(object)
      setUpdateMsg("Address added successfully!");
      addMutation.mutate({ ...addCurrentAdd, phone: fullPhone });
      setShowAdd(false);
    }
    
  };

  const deleteMutation = useMutation({
    mutationFn: deleteCustomerAddressAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["address"] });
      setTimeout(() => {
        setRemoveMsg("");
    }, 2000);
    },
  });
  const removeAddress = async (id, user_id) => {
    let conf = window.confirm("Are you sure, you want to delete this address?");
    if (conf) {
      setRemoveMsg("Address deleted successfully!");
      deleteMutation.mutate({ id, userId });
    }
  };

  const handlePhoneCode = (ph_code) => {
    setCurrentAdd({
      ...currentAdd,
      c_code: ph_code,
    });
  };

  const handleCountryChange = (selected) => {
    if (selected.length > 0) {
      let cur_country = selected[0];

      setCurrentAdd({
        ...currentAdd,
        country: cur_country,
      });
      getStateByCountry(cur_country);
      setTypehState([]);
    }
  };

  const handleAddCountryChange = (selected) => {
    if (selected.length > 0) {
      let cur_country = selected[0];

      setAddCurrentAdd({
        ...addCurrentAdd,
        country: cur_country,
      });
      getStateByCountry(cur_country);
      setAddTypehState([]);
    }
  };

  const handleStateChange = (selected) => {
    if (selected.length > 0) {
      let cur_state = selected[0]["name"];
      setCurrentAdd({
        ...currentAdd,
        state: cur_state,
      });
    }
  };

  const handleAddStateChange = (selected) => {
    if (selected.length > 0) {
      let cur_state = selected[0]["name"];
      setAddCurrentAdd({
        ...addCurrentAdd,
        state: cur_state,
      });
    }
  };

  const [intelValid, setIntelValid] = useState("");
  const handleIntel = (dv) => {
    setIntelValid(dv);
  };

  const handleAddAddress = () => {
    setAddTypehCountry([]);
    setAddTypehState([]);
    setAddCurrentAdd({
      customer_id: userId,
      contact_person_name: "",
      c_code: "",
      phone: "",
      address_type: "",
      country: "",
      state: "",
      city: "",
      zip: "",
      landmark: "",
      address: "",
    });
    setShowAdd(true);
  };

  return (
    <Layout title="My Addresses | Chaashni Couture">
      <div className="site-content-wrap my-account my-address-detail">
        <div className="container">
          <div className="row">
            <div className={`col-md-12`}>
              <h1 className="sustom-heading-h1">
                My <span>Addresses</span>{" "}
                <button
                  onClick={handleAddAddress}
                  className={`btn-primary btn`}
                >
                  + Add Address
                </button>
              </h1>
              {isLoading ? (
                <div className="loading-div">
                  <span>Loading...</span>
                </div>
              ) : (
                ""
              )}
              {removeMsg !== "" ? (
                <p className="danger-msg-address">{removeMsg}</p>
              ) : (
                ""
              )}
              <div className="content-box">
              {updateMsg !== "" ? (
                  <div className="success-msg-address">{updateMsg}
                  </div>
                ) : (
                  ""
                )}
                <div
                  className={`address-section ${isLoading ? "loading" : ""}`}
                >
                  <ul>
                    {addrData?.map((e, i) => (
                      <li key={i}>
                        <div className="address-box">
                          <div className="address-place">
                            <span>{e?.address_type}</span>
                          </div>
                          <div className="address-name">
                            {e?.contact_person_name}, {e?.phone}
                          </div>
                          <div className="address-detail">
                            {e?.address}, {e?.city}, {e?.state} - {e?.zip},{" "}
                            {e?.country}
                          </div>
                        </div>
                        <div className="editbtn">
                          <span className="address-edit">
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                          </span>
                          <ul>
                            <li
                              onClick={() => {
                                handleEdit(e?.id);
                              }}
                            >
                              Edit
                            </li>
                            <li
                              onClick={() => {
                                removeAddress(e?.id, userId);
                              }}
                            >
                              delete
                            </li>
                          </ul>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <Modal show={show} onHide={handleClose} className="address-popup">
            <Form
              noValidate
              validated={validated}
              onSubmit={handleUpdateAddress}
              className="edit-address-form"
            >
              <Modal.Header closeButton>
                <Modal.Title>Edit Address</Modal.Title>
              </Modal.Header>
              <Modal.Body className="custom-add">               
                <div className="address-form-wrap">
                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.ContactPersonName"
                >
                  <Form.Control
                    type="text"
                    name="contact_person_name"
                    placeholder="Contact person name"
                    value={currentAdd?.contact_person_name}
                    onChange={changeHandle}
                    autoFocus
                    required
                  />
                </Form.Group>
                <Form.Group
                  className="mb-3 ph-country custom-50"
                  controlId="exampleForm.Phone"
                >
                  {/* <CountryPhone code={currentAdd.c_code} selectedCode={handlePhoneCode}/>
                        <Form.Control type="text" placeholder="Phone" name="phone" required value={getOnlyPhoneNo(currentAdd?.c_code,currentAdd.phone)} onChange={changeHandle}/> */}

                  <div className="login-data mobile-field">
                    <IntlTelInputBox
                      setFullPhone={setFullPhone}
                      selectedPhone={fullPhone}
                      handleIntel={handleIntel}
                    />
                  </div>
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.Addresstype"
                >
                  <Form.Control
                    type="text"
                    placeholder="Address type"
                    name="address_type"
                    required
                    value={currentAdd?.address_type}
                    onChange={changeHandle}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.Counrty"
                >
                  <Typeahead
                    inputProps={{ required: true }}
                    id="basic-typeahead-single"
                    labelKey="name"
                    onChange={(selected) => {
                      handleCountryChange(selected);
                      setTypehCountry(selected);
                    }}
                    options={allCountry}
                    placeholder="Choose a country..."
                    selected={typehCountry}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.State"
                >
                  <Typeahead
                    inputProps={{ required: true }}
                    id="basic-typeahead-single"
                    labelKey="name"
                    onChange={(selected) => {
                      handleStateChange(selected);
                      setTypehState(selected);
                    }}
                    options={currentState}
                    placeholder="Choose a state..."
                    selected={typehState}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.City"
                >
                  <Form.Control
                    type="text"
                    placeholder="City"
                    name="city"
                    required
                    value={currentAdd?.city}
                    onChange={changeHandle}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.Ziocode"
                >
                  <Form.Control
                    type="text"
                    placeholder="Zipcode"
                    name="zip"
                    required
                    value={currentAdd?.zip}
                    onChange={changeHandle}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.Landmark"
                >
                  <Form.Control
                    type="text"
                    placeholder="Landmark"
                    name="landmark"
                    value={currentAdd?.landmark}
                    onChange={changeHandle}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-100"
                  controlId="exampleForm.Address"
                >                  
                  <Form.Control
                    as="textarea"
                    name="address"
                    placeholder="Address"
                    required
                    rows={3}
                    value={currentAdd?.address}
                    onChange={changeHandle}
                  />
                </Form.Group>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" type="submit">
                  Save Changes
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
          <Modal show={showAdd} onHide={() => setShowAdd(false)}  className="address-popup" >
            <Form
              noValidate
              validated={addValidated}
              onSubmit={handleAddAddressSubmit}
              className="add-address-form edit-address-form"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Add Address{" "}
                  <CurrentLocation
                    setTypehState={setAddTypehState}
                    setAddCurrentAdd={setAddCurrentAdd}
                    setTypehCountry={setAddTypehCountry}
                  />
                </Modal.Title>
              </Modal.Header>
              
              <Modal.Body className="custom-add">
              <div className="address-form-wrap">
                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.ContactPersonName"
                >
                  <Form.Control
                    type="text"
                    name="contact_person_name"
                    placeholder="Contact person name"
                    value={addCurrentAdd?.contact_person_name}
                    onChange={addChangeHandle}
                    autoFocus
                    required
                  />
                </Form.Group>
                <Form.Group
                  className="mb-3 ph-country custom-50"
                  controlId="exampleForm.Phone"
                >
                  {/* <CountryPhone code={currentAdd.c_code} selectedCode={handlePhoneCode}/>
                        <Form.Control type="text" placeholder="Phone" name="phone" required value={getOnlyPhoneNo(currentAdd?.c_code,currentAdd.phone)} onChange={changeHandle}/> */}

                  <div className="login-data mobile-field">
                    <IntlTelInputBox
                      setFullPhone={setFullPhone}
                      selectedPhone={""}
                      handleIntel={handleIntel}
                    />
                  </div>
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.Addresstype"
                >
                  <Form.Control
                    type="text"
                    placeholder="Address type"
                    name="address_type"
                    required
                    value={addCurrentAdd?.address_type}
                    onChange={addChangeHandle}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.Counrty"
                >
                  <Typeahead
                    inputProps={{ required: true }}
                    id="basic-typeahead-single"
                    labelKey="name"
                    onChange={(selected) => {
                      handleAddCountryChange(selected);
                      setAddTypehCountry(selected);
                    }}
                    options={allCountry}
                    placeholder="Choose a country..."
                    selected={addTypehCountry}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.State"
                >
                  <Typeahead
                    inputProps={{ required: true }}
                    id="basic-typeahead-single"
                    labelKey="name"
                    onChange={(selected) => {
                      handleAddStateChange(selected);
                      setAddTypehState(selected);
                    }}
                    options={currentState}
                    placeholder="Choose a state..."
                    selected={addTypehState}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.City"
                >
                  <Form.Control
                    type="text"
                    placeholder="City"
                    name="city"
                    required
                    value={addCurrentAdd?.city}
                    onChange={addChangeHandle}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.Ziocode"
                >
                  <Form.Control
                    type="text"
                    placeholder="Zipcode"
                    name="zip"
                    required
                    value={addCurrentAdd?.zip}
                    onChange={addChangeHandle}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-50"
                  controlId="exampleForm.Landmark"
                >
                  <Form.Control
                    type="text"
                    placeholder="Landmark"
                    name="landmark"
                    value={addCurrentAdd?.landmark}
                    onChange={addChangeHandle}
                  />
                </Form.Group>

                <Form.Group
                  className="mb-3 custom-100"
                  controlId="exampleForm.Address"
                >                  
                  <Form.Control
                    as="textarea"
                    name="address"
                    placeholder="Address"
                    required
                    rows={3}
                    value={addCurrentAdd?.address}
                    onChange={addChangeHandle}
                  />
                </Form.Group>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" type="submit">
                  Save
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </div>
      </div>
    </Layout>
  );
};

export default MyAddress;
